import { Badge } from "@chakra-ui/react"

type DocumentStatusBadgeProps = {
  status?: string | null
  fontSize?: string
}

export const getDocumentStatusColorScheme = (status?: string | null) => {
  if (status === "open") return "pink"
  if (status === "draft") return "yellow"
  if (status === "confirmed") return "green"
  if (status === "partially_confirmed") return "orange"
  if (status === "partially_realized") return "orange"
  if (status === "realized") return "blue"
  if (status === "cancelled") return "red"
  return undefined
}

export const getDocumentStatusLabel = (status?: string | null) => {
  if (!status) return "—"
  if (status === "open") return "Otwart."
  if (status === "draft") return "Szkic"
  if (status === "confirmed") return "Potw."
  if (status === "partially_confirmed") return "Cz. potw."
  if (status === "partially_realized") return "Cz. zreal."
  if (status === "realized") return "Zreal."
  if (status === "cancelled") return "Anul."
  return status
}

export default function DocumentStatusBadge({
  status,
  fontSize = "md",
}: DocumentStatusBadgeProps) {
  return (
    <Badge
      colorScheme={getDocumentStatusColorScheme(status)}
      fontSize={fontSize}
      whiteSpace="nowrap"
    >
      {getDocumentStatusLabel(status)}
    </Badge>
  )
}
